import React, { MouseEventHandler } from 'react';
import { getMachineDcGroups } from './util';
import './RebootAll3dApp.css';

interface iRebootProps {
    machineList: any[]
}

function RestartMachine(props: iRebootProps) {

    const onSubmit: MouseEventHandler<HTMLButtonElement> = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();

        const button = event.target as HTMLButtonElement;

        const datacenter = button.name;

        const secretKey = prompt("Please enter key:");

        // confirmation window to confirm that user wants to reboot
        if (window.confirm("You are rebooting all machines in " + datacenter + ", please confirm")) {

            for (let i = 0; i < props.machineList.length; i++) {
                // if machine is in selected datacenter call reboot function
                if (props.machineList[i].datacenter === datacenter) {

                    if (i === 0) {
                        reboot(props.machineList[i].hostName + "/restartMachine", props.machineList[i].sessionIP, secretKey, true)
                    } else {
                        reboot(props.machineList[i].hostName + "/restartMachine", props.machineList[i].sessionIP, secretKey, false)
                    }
                }
            }
        }
    }
    
    function reboot (theUrl: string, machineIp: string, secretKey: any, firstElement: boolean) {

        // calculate POST body and setup
        const jsonBody = {
            ipForMachine: machineIp,
            secretKey: secretKey,
        }

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
    
        const raw = JSON.stringify(jsonBody);
    
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
    
        // fetch call that sends post request
        fetch(theUrl, requestOptions)
        .then(response => response.text())
        .then(result => {

            if (firstElement) {
                alert(result);
            }

            console.log(result);
        })
        .catch(error => {

            if (firstElement) {
                alert(error);
            }

            console.log('error ', error);
        });
    }

    const datacenters = getMachineDcGroups(props.machineList);

    return (
        <form >
            <div className="btns">
                {Object.keys(datacenters).map(dc => {
                    return <button onClick={onSubmit} key={dc} name={dc}>Restart Machines {dc}</button>
                })}
            </div>
        </form>
    );
}
 
export default RestartMachine;